import React from 'react';
import { Shimmer } from '../shimmer/Shimmer';
const RadioShimmer = () => {
    return React.createElement(Shimmer, { height: 16, width: '100%' });
};
export default RadioShimmer;
